// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    //suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};
  InstantSearchResultItemPopular.prototype.compileTemplate = function() {
    console.log(this)
    if (!this.isShow) {
      return '';
    }

    // Customize redirect link
    if (this.parent.type == "default_suggestions") {
      if (this.data == 'linen bedding') {
        this.searchLink = 'https://www.secretlinenstore.com/collections/linen-bedding';
        this.redirectLink = 'https://www.secretlinenstore.com/collections/linen-bedding';
      }
      if (this.data == 'cotton bedding') {
        this.searchLink = 'https://www.secretlinenstore.com/collections/cotton-bedding';
        this.redirectLink = 'https://www.secretlinenstore.com/collections/cotton-bedding';
      }
      if (this.data == 'blackout curtains') {
        this.searchLink = 'https://www.secretlinenstore.com/collections/blackout-curtains';
        this.redirectLink = 'https://www.secretlinenstore.com/collections/blackout-curtains';
      }
      if (this.data == 'linen curtains') {
        this.searchLink = 'https://www.secretlinenstore.com/collections/linen-curtains';
        this.redirectLink = 'https://www.secretlinenstore.com/collections/linen-curtains';
      }
      if (this.data == 'throws') {
        this.searchLink = 'https://www.secretlinenstore.com/collections/throws';
        this.redirectLink = 'https://www.secretlinenstore.com/collections/throws';
      }
      if (this.data == 'nightwear') {
        this.searchLink = 'https://www.secretlinenstore.com/collections/nightwear';
        this.redirectLink = 'https://www.secretlinenstore.com/collections/nightwear';
      }
      if (this.data == 'towels') {
        this.searchLink = 'https://www.secretlinenstore.com/collections/towels';
        this.redirectLink = 'https://www.secretlinenstore.com/collections/towels';
      }
    }
    
    var searchTerm = Utils.stripHtml(Globals.currentTerm);
    var highlightedSuggestionResult = this.data;
    if (this.parent.type == InstantSearchEnum.ResultType.SUGGESTIONS) {
      highlightedSuggestionResult = this._highlightSuggestionResult(this.data, searchTerm);
    }
  
    return this.getTemplate()
      .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
      .replace(/{{escapedData}}/g, Utils.stripHtml(this.data))
      .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
      .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem)
      .replace(/{{searchLink}}/g, this.searchLink)
      .replace(/{{highlightedSuggestionResult}}/g, highlightedSuggestionResult);
  }
})();